export const confirmDeduplicationModalName = 'confirm-deduplication';
